import React, { useState } from "react";
import { FaTrash, FaUpload } from "react-icons/fa";
import { CgSoftwareUpload } from "react-icons/cg";
import "./AddBlog.css";
import axios from 'axios';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const categories = [
	"Welfare",
	"Environment",
	"Empowerment",
	"Youth",
	"Education",
	"Culture",
	"Harmony",
	"Spirituality",
	"Infrastructure",
	"Events",
];

const AddBlog = () => {
	const [content, setContent] = useState({
		data: [
			{ type: "title", value: "" },
			{ type: "paragraph", value: "" },
		],
		category: [],
		image: null,
	});
	const [preview, setPreview] = useState(null);
	const [isCategoryPopupOpen, setIsCategoryPopupOpen] = useState(false);

	const navigate = useNavigate();

	const addBlock = (type) => {
		setContent((prevContent) => ({
			...prevContent,
			data: [
				...prevContent.data,
				{ type, value: "" },
			],
		}));
	};

	const handleTextChange = (index, value) => {
		setContent((prevContent) => ({
			...prevContent,
			data: prevContent.data.map((block, i) =>
				i === index ? { ...block, value } : block
			),
		}));
	};

	const handleImageUpload = (file) => {
		const reader = new FileReader();
		setContent((prevContent) => ({
			...prevContent,
			image: file,
		}));
		reader.onload = () => {
			setPreview(reader.result);
		};
		reader.readAsDataURL(file);
	};

	const removeBlock = (index) => {
		setContent((prevContent) => ({
			...prevContent,
			data: prevContent.data.filter((_, i) => i !== index),
		}));
	};

	const handleCategorySelect = (category) => {
		setContent((prevContent) => {
			const updatedCategories = [...prevContent.category];
			if (updatedCategories.includes(category)) {
				updatedCategories.splice(updatedCategories.indexOf(category), 1);
			} else {
				updatedCategories.push(category);
			}
			return {
				...prevContent,
				category: updatedCategories,
			};
		});
	};

	const handlePopupSubmit = async (e) => {
		e.preventDefault();
		setIsCategoryPopupOpen(false);
		console.log("Post content:", content);

		const dataToSend = new FormData();
		dataToSend.append('image', content.image);
		dataToSend.append('data', JSON.stringify(content.data));
		dataToSend.append('category', JSON.stringify(content.category));

		const adminToken = localStorage.getItem("adminToken");
		try {
			const response = await axios.post(`${backendUrl}/blog`, dataToSend, {
				headers: {
					'Content-Type': 'multipart/form-data',
					Authorization: `Bearer ${adminToken}`,
				},
			});

			if (response.status === 201) {
				navigate('/articles');
				toast.success(response.data.message || "Blog created successfully!", {
					position: "top-center",
					theme: "dark",
				});
			} else {
				toast.error("Something went Wrong..!", {
					position: "top-center",
					theme: "dark",
				});
			}
		} catch (error) {
			toast.error("Failed to create Blog..!", {
				position: "top-center",
				theme: "dark",
			});
			console.error(error);
		}
	};

	return (
		<div className="addPostContainer">
			<div className="imageBlock">
				{content.image ? (
					<div className="imagePreview">
						<img
							src={preview}
							alt="Uploaded"
							className="imagePreviewImg"
						/>
						<label className="uploadButton">
							<input
								type="file"
								accept="image/*"
								onChange={(e) => handleImageUpload(e.target.files[0])}
								className="hidden"
							/>
							<CgSoftwareUpload />
						</label>
					</div>
				) : (
					<label className="imageUploadLabel">
						<input
							type="file"
							accept="image/*"
							onChange={(e) => handleImageUpload(e.target.files[0])}
							className="hidden"
						/>
						<div className="imageUploadText">
							<FaUpload className="uploadIcon" />
							<span>Click or drag to upload an image</span>
						</div>
					</label>
				)}
			</div>
			{content.data.map((block, index) => (
				<div key={index}>
					{block.type === "title" && (
						<div className="contentBlock">
							<input
								type="text"
								placeholder="Add Title"
								value={block.value}
								onChange={(e) => handleTextChange(index, e.target.value)}
								className="titleInput"
							/>
							{index > 1 && (
								<button
									onClick={() => removeBlock(index)}
									className="removeButton"
								>
									<FaTrash />
								</button>
							)}
						</div>
					)}
					{block.type === "paragraph" && (
						<div className="contentBlock">
							<textarea
								placeholder="Enter paragraph"
								value={block.value}
								onChange={(e) => handleTextChange(index, e.target.value)}
								className="paragraphInput"
								rows={1}
							></textarea>
							{index > 2 && (
								<button
									onClick={() => removeBlock(index)}
									className="removeButton"
								>
									<FaTrash />
								</button>
							)}
						</div>
					)}
				</div>
			))}

			<div className="addButtonContainer">
				<div className="addBlockButton">
					+
					<div className="addBlockOptions">
						<button
							onClick={() => addBlock("title")}
							className="addBlockOption"
						>
							Title
						</button>
						<button
							onClick={() => addBlock("paragraph")}
							className="addBlockOption"
						>
							Paragraph
						</button>
					</div>
				</div>
			</div>

			{/* Next Button */}
			<button onClick={() => setIsCategoryPopupOpen(true)} className="nextButton">
				Next
			</button>

			{/* Category Popup */}
			{
				isCategoryPopupOpen && (
					<div className="categoryPopup">
						<div className="categoryPopupContent">
							<h3>Select Categories</h3>
							<div className="categoryButtons">
								{categories.map((category) => (
									<button
										key={category}
										onClick={() => handleCategorySelect(category)}
										className={`categoryButton ${content.category.includes(category) ? "selected" : ""}`}
									>
										{category}
									</button>
								))}
							</div>
							<button onClick={handlePopupSubmit} className="submitButton">
								Submit Post
							</button>
							<button onClick={() => setIsCategoryPopupOpen(false)} className="closeButton">
								Close
							</button>
						</div>
					</div>
				)
			}
		</div >
	);
};

export default AddBlog;
